export const searchParamToFacet = {
  starRatings: {
    param: 'starRatings',
    facet: 'starRating',
    categoryType: 'StarRating'
  },
  themes: {
    param: 'themes',
    facet: 'themeIds',
    categoryType: 'Theme'
  },
  facilities: {
    param: 'facilities',
    facet: 'facilities',
    categoryType: 'Facility'
  },
  propertyTypes: {
    param: 'propertyTypes',
    facet: 'propertyTypeId',
    categoryType: 'PropertyType'
  },
  priceMin: {
    param: 'priceMin',
    facet: 'pricing.medianRateBkt',
    categoryType: 'PriceMin'
  },
  priceMax: {
    param: 'priceMax',
    facet: 'pricing.medianRateBkt',
    categoryType: 'PriceMax'
  },
  reviewScore: {
    param: 'reviewScore',
    facet: 'guestRating.overall',
    categoryType: 'ReviewScore'
  },
  objectID: {
    param: 'objectID',
    facet: 'objectID',
    categoryType: 'ObjectID'
  },
  hotelName: {
    param: 'hotelName',
    facet: 'hotelName',
    categoryType: 'HotelName'
  }
}

export const filterParamNames = [
  'reviewScore',
  'starRatings',
  'propertyTypes',
  'facilities',
  'themes',
  'hotelName',
  'priceMin',
  'priceMax',
  'freeCancellation',
  'chainIds',
  'amenities',
  'dealFreeze' // Added as a part of c747927f-deal-freeze-srp
]

export const HOSTEL_PROPERTY_TYPE_ID = '5'

export const PRICE_BUCKETS_COUNT = 31
export const PRICE_BUCKET_WIDTH = 10

export const SORT_FIELD_PRICE = 'price'
export const SORT_FIELD_DISTANCE = 'distance'
export const SORT_FIELD_GUEST_RATING = 'guestRating'
export const SORT_FIELD_STAR_RATING = 'starRating'
/** Tier/score ranking SAPI applies for crawler-facing SEO SRPs. Not a user-selectable option. */
export const SORT_FIELD_SEO = 'seo'

export const MAX_NO_RESULT = 3

export const persistedUTMParamsKeys = [
  'utm_campaign',
  'utm_source',
  'utm_medium',
  'utm_referrer',
  'utm_term',
  'utm_content',
  'label',
  'vtm_src',
  'pac'
] as const

const persistedFilterKeys = [
  'facilities',
  'freeCancellation',
  'starRatings',
  'priceMin',
  'priceMax',
  'propertyTypes',
  'themes',
  'amenities',
  'reviewScore',
  'sortOrder',
  'sortField',
  'dealFreeze' // Added as a part of c747927f-deal-freeze-srp
] as const

export const persistedBaseUrlParamKeys = [
  'token',
  'layout',
  'profile',
  ...persistedUTMParamsKeys
]

export const persistedUrlParamKeys = [
  ...persistedBaseUrlParamKeys,
  ...persistedFilterKeys
] as const

/**
 * Spread into a navigation that merges the current URL params to drop the
 * meta landing token, which only works for the hotel and dates the user
 * landed on
 */
export const droppedMetaLandingParams = {
  esd: undefined,
  epv: undefined,
  preferredRate: undefined
}

export const metaLandingParamKeys = Object.keys(droppedMetaLandingParams)
